export const PAYMENT_ACTION_STATUS = {
  UNKNOWN: 'UNKNOWN',
  NONE: 'NONE',
  IN_PROGRESS: 'IN_PROGRESS',
  BLOCKED: 'BLOCKED',
}

export const PAYMENT_STATUS = {
  UNKNOWN: 'UNKNOWN',
  OPEN: 'OPEN',
  IN_PROGRESS: 'IN_PROGRESS',
  CONFIRM: 'CONFIRM',
  SUCCESS: 'SUCCESS',
  CANCEL: 'CANCEL',
  REFUND: 'REFUND',
  FAILED: 'FAILED',
}

export const SLIP_STATUS = {
  REFUND: 'REFUND',
  REJECT: 'REJECT',
  COMPLETE: 'COMPLETE',
  IN_PROGRESS: 'IN_PROGRESS',
}

export const SLIP_IN_PROGRESS_STATUS = {
  UNKNOWN: 'UNKNOWN',
  NONE: 'NONE',
  OUT_QUEUE: 'OUT_QUEUE',
  BAD_SLIP: 'BAD_SLIP',
}

export const TRANSACTION_STATUS = {
  UNKNOWN: 'UNKNOWN',
  PAID: 'PAID',
  UNPAID: 'UNPAID',
}

export const ORDER_TYPE = {
  UNKNOWN: 'UNKNOWN',
  LOTTERY: 'LOTTERY',
  LOTTERY_NO_FEE: 'LOTTERY_NO_FEE',
  LOTTERY_SAFE: 'LOTTERY_SAFE',
  LOTTERY_DELIVERY: 'LOTTERY_DELIVERY',
  POINT: 'POINT',
  PRE_ORDER: 'PRE_ORDER',
  WITHDRAW: 'WITHDRAW',
  COUPON_ORDER: 'COUPON_ORDER',
}

export const SORT_ORDER = {
  ASC: 'ASC',
  DESC: 'DESC',
}

export const UNASSIGNED_TIME = '0001-01-01T00:00:00Z'

export const PAYMENT_METHOD = {
  CASH: 'CASH',
  POINT: 'POINT',
}

export const INITIAL_SEARCH_PARAMS = {
  page: 1,
  limit: 20,
  orderType: ORDER_TYPE.UNKNOWN,
  status: PAYMENT_STATUS.UNKNOWN,
  inProgress: SLIP_IN_PROGRESS_STATUS.UNKNOWN,
  action: PAYMENT_ACTION_STATUS.NONE,
  sort: SORT_ORDER.ASC,
  orderNo: '',
  'user.userNo': '',
  'user.firstName': '',
  'user.lastName': '',
  'user.phone': '',
}
